import React from 'react';
import Button from '$/components/base/Button';
import IconFont from '$/components/IconFont';
import { useLanguageStore } from '$/store/languageStore';
import classNames from 'classnames';
import { Slider } from 'antd';
import style from './index.module.scss';

interface SliderBoxProps {
  enable?: boolean;
  value: number;
  onChange: (value: number) => void;
  onAfterChange?: (value: number) => void;
  toggleEnable?: (v: boolean) => void;
  onClear?: () => void;
  min?: number;
  max?: number;
  step?: number;
}
export default function SliderBox({
  enable, value, onChange, onAfterChange, toggleEnable, onClear, min = 1, max = 100, step = 1,
}: SliderBoxProps) {
  const languageStore = useLanguageStore((state) => state.languageStore);

  return (
    <div className={style.slider_box}>
      {!!toggleEnable && (
        <div className={style.left_box}>
          <div className={classNames(style.plus_box, { [style.active]: !enable })} onClick={() => toggleEnable?.(false)}>
            <IconFont name="plusCircleBold" fontSize={16} color="var(--content-buttonSecondary)" className={style.icon} />
          </div>
          <div className={style.line} />
          <div className={classNames(style.minus_box, { [style.active]: enable })} onClick={() => toggleEnable?.(true)}>
            <IconFont name="minusCircleBold" fontSize={16} color="var(--content-buttonSecondary)" className={style.icon} />
          </div>
        </div>
      )}
      <div className={style.slider_box_content}>
        <Slider
          value={value}
          onChange={onChange}
          onAfterChange={onAfterChange}
          min={min}
          max={max}
          step={step}
          tooltip={{ getPopupContainer: (triggerNode) => triggerNode.parentElement || document.body }}
        />
      </div>
      {!!onClear && (
      <Button
        type="transparent"
        className={style.clear_button}
        onClick={onClear}
      >
        <IconFont name="trashCanV2Bold" fontSize={14} color="var(--content-buttonSecondary)" className={style.clear_icon} />
        {languageStore.smartcatTranslationText((v) => v.clear)}
      </Button>
      )}

    </div>
  );
}
